const _excluded = ["workspace"],
  _excluded2 = ["id"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from "./BusinessSwitcher.module.scss";
import { TextButton, PopoverOnHover, MenuItem, Typography } from 'seagull';
import { WideArrowDownward, Company24, Plus } from 'seagull/icons';
import { useSwitchBusiness } from "../../../../../hooks/useSwitchBusiness";
import { isValidWorkspace } from "./BusinessSwitcher.utils";
import { useStore, useStoreActions } from "../../../../../contexts";
import { selectors } from "../../../../../store/state-selectors";
const testIdPrefix = 'business-switcher';
const Logo = _ref => {
  let {
    src,
    className
  } = _ref;
  const [loadingImage, setLoadingImage] = useState(true);
  const [imageError, setImageError] = useState(false);
  useEffect(() => {
    setLoadingImage(true);
    setImageError(false);
  }, [src]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.logo, className)
  }, (loadingImage || imageError) && /*#__PURE__*/React.createElement("div", {
    className: styles.companyLogoPlaceholder
  }, /*#__PURE__*/React.createElement(Company24, null)), !imageError && /*#__PURE__*/React.createElement("img", {
    src: src || '',
    className: cn(styles.logoImage, {
      [styles.loadingLogoImage]: loadingImage
    }),
    height: "24px",
    onLoad: () => {
      setLoadingImage(false);
    },
    onError: () => {
      setLoadingImage(false);
      setImageError(true);
    }
  }));
};
const BusinessSwitcherItem = _ref2 => {
  let {
      workspace
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  const {
    id,
    logoUrl,
    name,
    features
  } = workspace;
  return /*#__PURE__*/React.createElement(MenuItem, _extends({
    value: id,
    className: styles.selectableItem
  }, rest), /*#__PURE__*/React.createElement(Logo, {
    src: logoUrl || '',
    className: cn(styles.imageAsideText, styles.asItemList)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.accountDescription
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    ellipsis: true
  }, name), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    skin: "secondary",
    ellipsis: true
  }, "".concat(features.accountsReceivable ? 'Service Provider' : 'Client', " account"))));
};
const BusinessSwitcherCreateNew = _ref3 => {
  let {
      id
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/React.createElement(MenuItem, _extends({
    value: id,
    className: styles.selectableItem,
    height: 20
  }, rest), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    skin: "link",
    ellipsis: true,
    className: styles.createNewLabel
  }, /*#__PURE__*/React.createElement(Plus, null), " Create an additional account"));
};
export const BusinessSwitcher = _ref4 => {
  var _userInfo$worksAt3, _userInfo$worksAt4;
  let {
    userInfo
  } = _ref4;
  const {
    logBI,
    resetBusinessData,
    setWorksAt
  } = useStoreActions();
  const {
    switchBusiness
  } = useSwitchBusiness();
  const isVendor = useStore(selectors.user.isVendor);
  const [open, setOpen] = useState(false);
  const validWorkspaces = (userInfo.workspaces || []).filter(isValidWorkspace);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testIdPrefix
  }, validWorkspaces.length > 1 || isVendor ? /*#__PURE__*/React.createElement(PopoverOnHover, {
    openStrategy: "click",
    removePadding: true,
    isOpen: open,
    onOpen: () => setOpen(true),
    trigger: triggerProps => {
      var _userInfo$worksAt, _userInfo$worksAt2;
      return /*#__PURE__*/React.createElement("div", _extends({}, triggerProps, {
        className: styles.trigger
      }), /*#__PURE__*/React.createElement(TextButton, {
        "data-testid": "".concat(testIdPrefix, "-trigger"),
        prefixIcon: /*#__PURE__*/React.createElement(Logo, {
          src: (_userInfo$worksAt = userInfo.worksAt) === null || _userInfo$worksAt === void 0 ? void 0 : _userInfo$worksAt.logoUrl
        }),
        suffixIcon: /*#__PURE__*/React.createElement(WideArrowDownward, null),
        skin: "secondary",
        underline: "none"
      }, (_userInfo$worksAt2 = userInfo.worksAt) === null || _userInfo$worksAt2 === void 0 ? void 0 : _userInfo$worksAt2.name));
    },
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.popover
    }, validWorkspaces.map((workspace, idx) => /*#__PURE__*/React.createElement(BusinessSwitcherItem, {
      "data-testid": "".concat(testIdPrefix, "-item-").concat(idx),
      key: workspace.id,
      workspace: workspace,
      onClick: () => {
        setOpen(false);
        switchBusiness(workspace.id);
      }
    })), isVendor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.separator
    }), /*#__PURE__*/React.createElement(BusinessSwitcherCreateNew, {
      id: "create-new",
      "data-testid": "".concat(testIdPrefix, "-item-create-new"),
      key: "create-new",
      onClick: () => {
        setOpen(false);
        logBI(11151);
        resetBusinessData();
        setWorksAt();
      }
    })))
  }) : /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(testIdPrefix, "-current-business-view-only"),
    className: styles.currentBusinessViewOnly
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imageAsideText
  }, /*#__PURE__*/React.createElement(Logo, {
    src: ((_userInfo$worksAt3 = userInfo.worksAt) === null || _userInfo$worksAt3 === void 0 ? void 0 : _userInfo$worksAt3.logoUrl) || ''
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.viewOnlyText
  }, /*#__PURE__*/React.createElement(Typography, {
    ellipsis: true,
    skin: "secondary"
  }, (_userInfo$worksAt4 = userInfo.worksAt) === null || _userInfo$worksAt4 === void 0 ? void 0 : _userInfo$worksAt4.name))));
};